module.exports = __webpack_public_path__ + "static/img/payment-alipay.057cba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-alipay.png
// module id = LtXU
// module chunks = 0